import { Box, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0px 112px",
    [theme.breakpoints.down("md")]: {
      padding: "0px",
    },
  },
  rootSection: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "24px 24px",
    boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("md")]: {
      padding: "20px 12px",
      borderRadius: "8px",
    },
  },
  heading: {
    fontWeight: 700,
    letterSpacing: "unset",
    fontSize: "20px",
    lineHeight: "28px",
    [theme.breakpoints.down("md")]: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  headingIcon: {
    fontSize: "20px",
    lineHeight: "28px",
    color: "#FBBB3E",
    marginRight: "8px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
}));

interface FAQNoResultsProps {
  searchText: string;
}

export const FAQNoResults = ({ searchText }: FAQNoResultsProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.rootSection}>
        <Stack direction="row">
          <Box className={classes.headingIcon}>
            <i className="fa-solid fa-triangle-exclamation"></i>
          </Box>
          <Typography variant="h3" component="div" className={classes.heading}>
            We couldn’t find a match for “{searchText}”. Please try another search.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
